import { render } from "./ShowCounter2.vue?vue&type=template&id=7ddef06c"
import script from "./ShowCounter2.vue?vue&type=script&lang=js"
export * from "./ShowCounter2.vue?vue&type=script&lang=js"

import exportComponent from "C:\\files\\vue3_lesson_demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__